export default (funcOrValue, ...args) =>
  typeof funcOrValue === 'function' ? funcOrValue(...args) : funcOrValue;
